import React from "react";
import { ArrowUpRight } from "lucide-react";
import { services } from "../data/mock";

const Services = () => {
  return (
    <section id="services" className="section bg-[#F8F5EE]">
      <div className="max-w-7xl mx-auto container-px">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-16 items-end">
          <div className="lg:col-span-7 reveal">
            <span className="eyebrow">Services — DianaMik Consultancy</span>
            <h2 className="h-section text-3xl lg:text-5xl mt-6">
              Hospitals partner with us for
              <br />
              <span className="italic">end-to-end transformation.</span>
            </h2>
            <div className="divider-gold" />
          </div>
          <p className="lg:col-span-5 text-[15px] text-[#0B1E3F]/75 leading-relaxed reveal">
            Six core service tracks — each delivered with the rigour of a quality consultancy and the agility of a boutique advisory.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((s, i) => (
            <article
              key={i}
              className="group bg-white border border-[#0B1E3F]/10 p-7 lg:p-8 card-lift reveal flex flex-col"
            >
              <div className="flex items-start justify-between">
                <span className="font-serif text-[#C9A961] text-2xl">0{i + 1}</span>
                <ArrowUpRight
                  size={18}
                  className="text-[#0B1E3F]/40 group-hover:text-[#C9A961] group-hover:rotate-45 transition-all duration-500"
                />
              </div>
              <h3 className="font-serif text-xl text-[#0B1E3F] mt-6 leading-snug">
                {s.title}
              </h3>
              <p className="mt-3 text-[14px] text-[#0B1E3F]/70 leading-relaxed">
                {s.blurb}
              </p>
              <ul className="mt-6 pt-6 border-t border-[#0B1E3F]/10 space-y-2">
                {s.deliverables.map((d, j) => (
                  <li
                    key={j}
                    className="flex items-center gap-2 text-[12.5px] text-[#0B1E3F]/70"
                  >
                    <span className="w-1 h-1 rounded-full bg-[#C9A961]" />
                    {d}
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>

        <div className="mt-14 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6 p-8 bg-[#0B1E3F] text-[#F8F5EE]">
          <div>
            <div className="text-[11px] tracking-[0.2em] uppercase text-[#C9A961]">Bespoke Engagement</div>
            <div className="font-serif text-2xl mt-2">Need something not listed here?</div>
          </div>
          <a href="#contact" className="btn-ghost text-[#F8F5EE] border-[#F8F5EE] hover:bg-[#F8F5EE] hover:text-[#0B1E3F]">
            Discuss your project <ArrowUpRight size={16} />
          </a>
        </div>
      </div>
    </section>
  );
};

export default Services;
